export const PAGE_TYPE = 'Kategori Komisyon Kampanyaları';

export const CAMPAIGN_BADGE_TYPES = {
  LAST_CHANCE: 'LAST_CHANCE',
  JUST_STARTED: 'JUST_STARTED',
  STARTING_SOON: 'STARTING_SOON',
};

export const JOINED_STATUS_TYPES = {
  JOINED: 'JOINED',
  WAITING_FOR_JOIN: 'WAITING_FOR_JOIN',
  REJECTED: 'REJECTED',
  COMPLETED: 'COMPLETED',
  PLANNED: 'PLANNED',
};

export const CAMPAIGN_TABS = {
  AVAILABLE: {
    text: 'available',
    code: 'TAB_AVAILABLE_TITLE',
    defaultTitle: 'Katılabileceğiniz Kampanyalar',
  },
  JOINED: {
    text: 'joined',
    code: 'TAB_JOINED_TITLE',
    defaultTitle: 'Katıldığınız Kampanyalar',
  },
};

export const DEFAULT_BADGE_TITLES = {
  [CAMPAIGN_BADGE_TYPES.LAST_CHANCE]: 'Katılmak için Son Şans',
  [CAMPAIGN_BADGE_TYPES.JUST_STARTED]: 'Yeni Başladı Hemen Katıl',
  [CAMPAIGN_BADGE_TYPES.STARTING_SOON]: 'Çok Yakında Başlıyor',
  [JOINED_STATUS_TYPES.JOINED]: 'Katılmış',
  [JOINED_STATUS_TYPES.WAITING_FOR_JOIN]: 'Katılmayı Bekliyor',
  [JOINED_STATUS_TYPES.REJECTED]: 'Reddedildi',
  [JOINED_STATUS_TYPES.COMPLETED]: 'Tamamlandı',
  [JOINED_STATUS_TYPES.PLANNED]: 'Planlandı',
};

export const STATUS_TOOLTIP_TEXT =
  'Geçerlilik süresi, toplam satış veya sipariş adedi limitlerinden herhangi birine ulaşıldığında kampanya sona erecektir.';

export const CAMPAIGN_DATES_TOOLTIP_TEXT =
  'Kampanya tarihleri, kampanyaya katılabileceğiniz tarih aralığını belirtir. Geçerlilik süresi ise katılım sonrası komisyon indiriminden faydalanacağınız süreyi gösterir.';

export const SORT_BY_OPTIONS = {
  HIGHEST_DISCOUNT: 'HIGHEST_DISCOUNT',
  NEAREST_START_DATE: 'NEAREST_START_DATE',
};

export const PAGE_SIZES = {
  10: '10 Kampanya',
  25: '25 Kampanya',
  50: '50 Kampanya',
};

export const URGENCY_BADGE_DEFAULTS = {
  STARTING_SOON: {
    title: 'Çok Yakında Başlıyor',
    colorCode: '#E5FF55',
    textColorCode: '#1C1C1E',
  },
  JUST_STARTED: {
    title: 'Yeni Başladı Hemen Katıl',
    colorCode: '#FFDA3D',
    textColorCode: '#1C1C1E',
  },
  LAST_CHANCE: {
    title: 'Katılmak İçin Son Şans',
    colorCode: '#56F7FF',
    textColorCode: '#1C1C1E',
  },
};

export const STATUS_BADGE_DEFAULTS = {
  JOINED: {
    title: 'Devam Ediyor',
    colorCode: '#E9F4FC',
    textColorCode: '#2B86D1',
  },
  COMPLETED: {
    title: 'Tamamlandı',
    colorCode: '#E5FAEC',
    textColorCode: '#0C9741',
  },
};
